import { createFileRoute } from '@tanstack/react-router';

import Stack from '@mui/material/Stack';

import { useOrganization } from '@/context/organization-context';
import { ProgramAuditView } from '@/sections/program-audit/program-audit-view';

// Hidden internal-testing route for the program audit. Not linked in nav —
// reachable by direct URL (/dashboard/o/:orgId/c/:clientId/audit). Manual
// trigger only; no customer-facing delivery.
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/audit')({
  component: ProgramAuditPage,
});

function ProgramAuditPage() {
  const { activeOrganization, activeClient } = useOrganization();
  const orgId = activeOrganization?.id;
  const clientId = activeClient?.id;

  if (!orgId || !clientId) return null;

  return (
    <Stack spacing={3} sx={{ p: { xs: 2, md: 3 }, maxWidth: 1100, mx: 'auto', width: '100%' }}>
      <ProgramAuditView orgId={orgId} clientId={clientId} />
    </Stack>
  );
}
